const ResultTypes = {
  SEARCH_ITEM_SUMMARY: 'search_item_summary',
  SEARCH_ORDER_SUMMARY: 'search_order_summary',
  SEARCH_EXPERIENCE_SUMMARY: 'search_experience_summary',
  SEARCH_EXPERIMENT_SUMMARY: 'search_experiment_summary',
};

export default ResultTypes;
